<template>
  <div>
    <simple-edit-base
      ref="simpleEditBase"
      v-bind="$data"
    >
      <template #header-before v-if="alertMsg">
        <zm-alert class="opc-zsched-top__alert" type="info">
          <span v-html="alertMsg" />
        </zm-alert>
      </template>
    </simple-edit-base>
  </div>
</template>
<script>
import SimpleEditBase from "@/components/simple-edit/base.vue";
import planCommon from "@/plans/ZOOM_SCHEDULER/mx/edit-delta";
import store from "@/store/index";

export default {
  name: "SchedulerEditSimple",
  components: { SimpleEditBase },
  mixins: [planCommon],
  data() {
    return {
      licensesMax: 9999,
    };
  },
  computed: {
    alertMsg() {
      const { boughtBizBundle } = store.getters.plansofBizBundle;
      return boughtBizBundle?.length > 0 ? this.$t('billing.scheduler.biz_include_tip') : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-zsched-top__alert {
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 16px;
  border-radius: 8px;
  background: #F7F7F8;
  margin-bottom: 24px;

  :deep(.zbo-banner__body) {
    padding: 0;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: 150%;
  }
}
</style>
